import { graphql } from "../gql";

export const getClaimAuditTypesQueryDoc = graphql(`
  query getClaimAuditTypes {
    claimAuditTypes {
      claimAuditTypeDescriptions {
        description
        type
      }
      claimAuditTypes
    }
  }
`);
